import React, { Component } from 'react';
import { ButtonToolbar, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import AuthService from '../../services/auth.service';
import '../../content/css/PortfolioAnalysis/PortfolioAnalysis.css';

export default class Navbar extends Component {
    constructor(props) {
        super(props);

        this.authService = new AuthService();
    }

    isTabActive = (type) => {
        let url = document.URL;
        switch (type) {
            case 'documents': return url.includes('documents') || !(url.includes('insights') || url.includes('duediligence') || url.includes('settings'));
            case 'insights': return url.includes('insights');
            case 'duediligence': return url.includes('duediligence');
            case 'settings': return url.includes('settings');
            default: true;
        }
    }

    render() {
        let isDocuments = this.isTabActive('documents');
        let isInsights = this.isTabActive('insights');
        let isDueDiligence = this.isTabActive('duediligence');
        let isSettings = this.isTabActive('settings');
        let isAdmin = this.authService.isAdmin();

        return (
            <ButtonToolbar className="navbar">
                <LinkContainer to={`${this.props.match.url}/insights`} activeClassName="">
                    <Button bsSize="large" active={isInsights}>
                        Insights
                    </Button>
                </LinkContainer>
                <LinkContainer to={`${this.props.match.url}/documents`} activeClassName="">
                    <Button bsSize="large" active={isDocuments}>
                        Documents
                    </Button>
                </LinkContainer>
                {/*<LinkContainer to={`${this.props.match.url}/duediligence`} activeClassName="">
                    <Button bsSize="large" active={isDueDiligence}>
                        Due Diligence
                    </Button>
                </LinkContainer>*/}
                {isAdmin &&
                    <LinkContainer to={`${this.props.match.url}/settings`} activeClassName="">
                        <Button bsSize="large" active={isSettings}>
                            Settings
                        </Button>
                    </LinkContainer>
                }
            </ButtonToolbar>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AnalysisReports/Navbar.js